const KEY_ACCESS_TOKEN = "CHAILD_WEB_ACCESS_TOKEN";
const KEY_AUTHORIZER = "CHAILD_WEB_AUTHORIZER";
const KEY_USER = "CHAILD_WEB_USER";
const KEY_NURSERY_ID = "CHAILD_WEB_NURSERY_ID";
const KEY_COMPANY = "CHAILD_WEB_COMPANY";
const KEY_COMPANY_ID = "CHAILD_WEB_COMPANY_ID";

class LocalAuthorizer {
  public email: string = "";
  public iss: string = "";
  public sub: string = "";
  public iat: number = 0;
  public exp: number = 0;
}

export default class LocalDataService {

  // =========================
  // ACCESS TOKEN
  // =========================
  public static setAccessToken(token: string) {
    // ��Bearer��t���Ȃ��i�d�v�j
    localStorage.setItem(KEY_ACCESS_TOKEN, token);
    return token;
  }

  public static getAccessToken(): string | null {
    return localStorage.getItem(KEY_ACCESS_TOKEN);
  }

  public static clearAccessToken() {
    localStorage.removeItem(KEY_ACCESS_TOKEN);
  }

  // =========================
  // AUTH CHECK�i�ǉ��F���d�v�j
  // =========================
  public static isLoggedIn(): boolean {
    return !!this.getAccessToken();
  }

  // =========================
  // AUTHORIZER
  // =========================
  public static setAuthorizer(authorizer: any) {
    localStorage.setItem(KEY_AUTHORIZER, JSON.stringify(authorizer));
    return authorizer;
  }

  public static getAuthorizer() {
    const saved = localStorage.getItem(KEY_AUTHORIZER);
    if (!saved) return new LocalAuthorizer();

    try {
      return JSON.parse(saved);
    } catch {
      return new LocalAuthorizer();
    }
  }

  // =========================
  // USER
  // =========================
  public static setUser(account: any) {
    localStorage.setItem(KEY_USER, JSON.stringify(account));
    return account;
  }

  public static getUser() {
    const saved = localStorage.getItem(KEY_USER);
    if (!saved) return null;

    try {
      return JSON.parse(saved);
    } catch {
      return null;
    }
  }

  // =========================
  // COMPANY
  // =========================
  public static setCompany(company: any) {
    localStorage.setItem(KEY_COMPANY, JSON.stringify(company));
    return company;
  }

  public static getCompany() {
    const saved = localStorage.getItem(KEY_COMPANY);
    if (!saved) return null;

    try {
      return JSON.parse(saved);
    } catch {
      return null;
    }
  }

  // =========================
  // IDS
  // =========================
  public static setNurseryId(id: number) {
    localStorage.setItem(KEY_NURSERY_ID, String(id));
    return id;
  }

  public static getNurseryId(): number | null {
    const id = localStorage.getItem(KEY_NURSERY_ID);
    return id ? Number(id) : null;
  }

  public static setCompanyId(id: number) {
    localStorage.setItem(KEY_COMPANY_ID, String(id));
    return id;
  }

  public static getCompanyId(): string | null {
    return localStorage.getItem(KEY_COMPANY_ID);
  }

  // =========================
  // CLEAR ALL�i�ǉ��F���O�A�E�g�p�j
  // =========================
  public static clearAll() {
    localStorage.removeItem(KEY_ACCESS_TOKEN);
    localStorage.removeItem(KEY_AUTHORIZER);
    localStorage.removeItem(KEY_USER);
    localStorage.removeItem(KEY_NURSERY_ID);
    localStorage.removeItem(KEY_COMPANY);
    localStorage.removeItem(KEY_COMPANY_ID);
  }
}